"use strict";

define('components/filter_bar/filters/dropdown_filters',[], function() {
    var dropdownFiltersComponent = {
        initWithContext: function(context) {
            _initData(context);

            var allMenus = context.dropdownFiltersData.allMenus;

            allMenus.find('li[data-filter] input').change(function() {
                var li = $(this).closest('li');
                var menu = li.closest('ul.dropdown-menu');

                if (li.hasClass('filter_unspecified') || li.hasClass('filter_unspecified_inverse')) {
                    menu.find('li.filter_item input').prop('checked', false);
                } else {
                    menu.find('li.filter_unspecified input').prop('checked', false);
                    menu.find('li.filter_unspecified_inverse input').prop('checked', false);
                }
                if (li.find('input:checked')[0]) {
                    _activateParentButton(li);
                } else if (!menu.find('input[type=checkbox]:checked')[0]) {
                    _deactivateParentButton(li);
                }

                _syncMenu(context, menu);

                var filterName = li.data('filter-name');
                context.pushState({
                    'buttonSelector': 'button[data-filter-name="' + filterName  + '"]',
                    'buttonState': context.hasFilter(filterName) ? 'selected' : 'unselected'
                });
            });

            // Selection options.
            allMenus.find('.select-options a').click(function(e) {
                e.preventDefault();
                e.stopPropagation();

                var link = $(this);
                var menu = link.closest('ul.dropdown-menu');

                if (link.is('.select-all')) {
                    var items = menu.find('li.filter_item:not(.disabled) input[type=checkbox]');
                    items.prop('checked', true);
                    _activateParentButton(items);
                } else if (link.is('.select-none')) {
                    var items = menu.find('li.filter_item:not(.disabled) input[type=checkbox]')
                    items.prop('checked', false);
                    _deactivateParentButton(items);
                } else if (link.is('.select-reverse')) {
                    menu.find('li.filter_item:not(.disabled) input[type=checkbox]').each(function() {
                        $(this).prop('checked', !$(this).prop('checked'));
                    });
                }

                _syncMenu(context, menu);

                var filterName = menu.data('filter-name');
                context.pushState({
                    'buttonSelector': 'button[data-filter-name="' + filterName  + '"]',
                    'buttonState': context.hasFilter(filterName)? 'selected' : 'unselected'
                });
            });
            
            // Group selection options.
            allMenus.find('.select-options.group a').click(function(e) {
                e.preventDefault();
                e.stopPropagation();

                var link = $(this);
                var menu = link.closest('ul.dropdown-menu');
                var groupRoot = link.closest('li');

                if (link.is('.select-all-group')) {
                    var items = groupRoot
                        .nextUntil('li:not(".filter_item")')
                        .filter('li.filter_item:not(.disabled)')
                        .find('input[type=checkbox]');
                    items.prop('checked', true);
                    _activateParentButton(items);
                } else if (link.is('.select-none-group')) {
                    var items = groupRoot
                        .nextUntil('li:not(".filter_item")')
                        .filter('li.filter_item:not(.disabled)')
                        .find('input[type=checkbox]');
                    items.prop('checked', false);
                    _deactivateParentButton(items);
                } else if (link.is('.select-reverse-group')) {
                    var items = groupRoot
                        .nextUntil('li:not(".filter_item")')
                        .filter('li.filter_item:not(.disabled)')
                        .find('input[type=checkbox]')
                        .each(function() {
                            $(this).prop('checked', !$(this).prop('checked'));
                        });
                }

                _syncMenu(context, menu);

                var filterName = menu.data('filter-name');
                context.pushState({
                    'buttonSelector': 'button[data-filter-name="' + filterName  + '"]',
                    'buttonState': context.hasFilter(filterName)? 'selected' : 'unselected'
                });
            });

            // Filter options.
            allMenus.find('li[data-filter-quantifier] input').change(function() {
                var menu = $(this).closest('ul.dropdown-menu');
                _activateParentButton($(this));

                _syncMenu(context, menu);

                context.markDirtyState();
            });

            allMenus.find('.show-filter-options a').click(function(e) {
                e.preventDefault();
                e.stopPropagation();

                var menu = $(this).closest('ul.dropdown-menu');

                menu.find('[data-visibility-group="show-filter-options"]').addClass('hidden');
                menu.find('[data-visibility-group="filter-options"]').removeClass('hidden');

                // Scroll to the bottom so that the options are always visible.
                menu.scrollTop(menu[0].scrollHeight);
            });

            allMenus.find('.clear-this-filter a').click(function(e) {
                e.preventDefault();

                var li = $(this).closest('li');
                var menu = li.closest('ul.dropdown-menu');

                menu.find('[data-visibility-group="show-filter-options"]').removeClass('hidden');
                menu.find('[data-visibility-group="filter-options"]').addClass('hidden');
                menu.find('li input:checked').prop('checked', false);

                _syncMenu(context, menu);

                var filterName = li.data('filter-name');
                context.pushState({
                    'buttonSelector': 'button[data-filter-name="' + filterName  + '"]',
                    'buttonState': 'unselected'
                });
                _deactivateParentButton(li);
            });

            allMenus.find('li.custom_date_range input').change(function() {
                context.buttonbarNode.find('button[data-filter-name="period"]')
                                     .addClass('hidden');

                context.buttonbarNode.find('form.custom_date_range')
                                     .removeClass('hidden');

                context.removeFilter('period');
            });
        },

        resetToDefaultUI: function(context) {
            var checkedBoxes = context.dropdownFiltersData.allMenus.find('li:not([data-filter-quantifier="any"]) input:checked');
            checkedBoxes.prop('checked', false);
        }
    };

    function _initData(context) {
        context.dropdownFiltersData = {
            allMenus: context.buttonbarNode.find('ul.dropdown-menu')
        };
    }

    function _syncMenu(context, menu) {
        var filterName = menu.data('filter-name');
        var countChecked = menu.find('li.filter_item input:checked').length;

        var isUnspecifiedSelected = menu.find('li.filter_unspecified input')
                                        .prop('checked');

        var isUnspecifiedSelected = isUnspecifiedSelected || menu.find('li.filter_unspecified_inverse input')
                                        .prop('checked');

        var shouldHideClearLink = !isUnspecifiedSelected && countChecked == 0;
        menu.find('[data-visibility-group="clear-filter"]')
            .toggleClass('hidden', shouldHideClearLink);

        // Make sure the quantifiers menu shows the correct list of choices.
        // For example, if the user first chooses the 'Not specified' quantifier but then later
        // chooses a particular filter value, the quantifier should switch from 'Not specified' to
        // 'Match any of the selected criteria'.
        var quantifiers = menu.find('li[data-filter-quantifier]');
        if (quantifiers.length > 0) {
            var disableQuantifiers = {
                any: countChecked < 1,
                all: countChecked < 2,
                none: countChecked < 1
            };
            var selectedQuantifier = quantifiers.find('input:checked')
                                                .closest('li')
                                                .data('filter-quantifier');
            var correctQuantifier = selectedQuantifier;
            if (!selectedQuantifier || disableQuantifiers[selectedQuantifier]) {
                correctQuantifier = isUnspecifiedSelected ? '' : 'any';
            }
            ['any', 'none', 'all'].forEach(function(quantifier) {
                var quantifierListItem = menu.find('li[data-filter-quantifier="' + quantifier + '"]');

                quantifierListItem.toggleClass('disabled', disableQuantifiers[quantifier]);

                quantifierListItem.find('input').prop({
                    disabled: disableQuantifiers[quantifier],
                    checked: correctQuantifier == quantifier
                });
            });
            context.setFilterQuantifier(filterName, correctQuantifier);
        }

        // Iterate through the dropdown checkboxes and determine which filters to apply / removed based on checked status.
        var groupsData = {};
        var currentGroupName = "";
        menu.find('li[data-filter]').each(function() {
            var li = $(this);
            var filterStr = li.data('filter');
            var groupName = li.data('group-name') || "";
            var inGroup = groupName.length > 0;

            // Initialized / moved out of current group.
            if (inGroup && (currentGroupName.length === 0 || groupName !== currentGroupName)) {
                currentGroupName = groupName;
                var groupFilterName = filterStr.split("=")[0];
                var groupData = {};
                groupData["filterName"] = groupFilterName;
                groupData["checkedCount"] = 0;
                groupData["totalCount"] = 0;
                groupData["applyFilters"] = [];
                groupData["removeFilters"] = [];
                groupsData[groupName] = groupData;
            }

            // If we are in a data group, keep count of total items. 
            if (inGroup) {
                groupsData[groupName]["totalCount"] += 1;
            }
            
            if (li.find('input').prop('checked')) {
                // If we are in a data group, keep count of checked items.
                if (inGroup) {
                    groupsData[groupName]["applyFilters"].push(filterStr);
                    groupsData[groupName]["checkedCount"] += 1;
                } else {
                    context.applyFilterFromString(filterStr);
                }
            } else {
                // Since we can no longer rely on the reloaded URL refreshing the buttonbar,
                // manually apply the active state to this menu's parent button.
                if (inGroup) {
                    groupsData[groupName]["removeFilters"].push(filterStr);
                }
                else {
                    context.removeFilter(filterStr);
                }
            }
        });
    
        // Iterate the groups and see which ones have all items selected.
        for (var groupName in groupsData) {
            var value = groupsData[groupName];
            var checkedCount = value["checkedCount"];
            var totalCount = value["totalCount"];
            var applyFilters = value["applyFilters"];
            var removeFilters = value["removeFilters"];
            var filterName = value["filterName"];

            // If all items are selected we want the filter to just be "-1".
            if (checkedCount > 0 && checkedCount === totalCount) {
                context.applyFilterFromString(filterName + "=-1");
                applyFilters.concat(removeFilters).forEach(function (filter) {
                    context.removeFilter(filter);
                });
            } 
            // If not all items selected, we need to add and remove filters as we normally would.
            else {
                context.removeFilter(filterName + "=-1");

                applyFilters.forEach(function (applyFilter) {
                    context.applyFilterFromString(applyFilter);
                });
                removeFilters.forEach(function (removeFilter) {
                    context.removeFilter(removeFilter);
                });
            }
        } 
    }

    function _activateParentButton(li) {
        var button = li.closest('ul').siblings('button');
        button.addClass('btn-selected');
    }

    function _deactivateParentButton(li) {
        var button = li.closest('ul').siblings('button');
        button.removeClass('btn-selected');
    }

    return dropdownFiltersComponent;
});

